import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Google Analytics 4 — activates only when REACT_APP_GA4_ID is set. No-op otherwise.
const GA_ID = process.env.REACT_APP_GA4_ID;
const GSC = process.env.REACT_APP_GSC_VERIFICATION;

export function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (GSC) {
      let m = document.head.querySelector('meta[name="google-site-verification"]');
      if (!m) { m = document.createElement("meta"); m.name = "google-site-verification"; document.head.appendChild(m); }
      m.content = GSC;
    }
    if (!GA_ID || window.__ga_loaded) return;
    window.__ga_loaded = true;
    const s = document.createElement("script");
    s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }, []);

  useEffect(() => {
    if (GA_ID && window.gtag) window.gtag("event", "page_view", { page_path: pathname });
  }, [pathname]);

  return null;
}
